<template>
    <el-container>
        <el-header>
            <el-row>
                <el-col :span="20">
                    <div class="nav-head-div">
                        <div class="nav-head-title">SONAR</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="nav-head-div">
                        <div class="nav-head-avatar">
                            <el-dropdown @command="handleCommand">
                                <span class="el-dropdown-link">
                                    <el-avatar :size="45">
                                        <img src="@/assets/touxiang.png" />
                                    </el-avatar>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="t">通讯录</el-dropdown-item>
                                    <el-dropdown-item command="m">修改密码</el-dropdown-item>
                                    <el-dropdown-item command="o">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <userspaceaddress :show.sync="showAddress"></userspaceaddress>
        </el-header>
        <el-container>
            <el-aside width="200px" :style="'height:' + (this.$tools.mainHeight()) + 'px;overflow-y:auto;overflow-x:hidden;'">
                <el-menu
                    class="nav-menu"
                    unique-opened
                    router
                    :default-active="defaultactive"
                    @select="selectMenu"
                >
                    <el-submenu :index="menu.router" v-for="menu in menus" :key="menu.id">
                        <template slot="title">
                            <i class="{menu.icon}" v-if="!!menu.icon"></i>
                            <span>{{ menu.name }}</span>
                        </template>
                        <el-menu-item :index="m.router" v-for="m in menu.sub" :key="m.id">
                            {{
                            m.name
                            }}
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import userspaceaddress from "./User-sapce-address.vue";
export default {
    components: { confirm, userspaceaddress },
    data() {
        return {
            showAddress: false,
            menus: [],
            showLoginout: false,
            defaultactive: null,
        };
    },
    methods: {
        handleCommand(command) {
            if (command == "o") {
                this.loginlout();
            } else if (command == "m") {
                this.changepswd();
            } else if (command == "t") {
                this.showAddress = true;
            }
        },
        loginlout() {
            let _this = this;
            _this.$tConfirm.show("确认推出登录？", function () {
                _this.$http.post(
                    ["/user/loginout"],
                    [
                        function () {
                            _this.$router.push("/login");
                            window.sessionStorage.clear();
                        },
                    ]
                );
            });
        },
        changepswd() {
            let _this = this;

            _this.$tPrompt.show("新密码", function (value) {
                _this.$http.post(["/user/updatepswd", { pswd: value }], []);
            });
        },
        getMenu() {
            let _this = this;

            if (window.sessionStorage.getItem("menus")) {
                _this.menus = JSON.parse(
                    window.sessionStorage.getItem("menus")
                );
                _this.setFirstRouter(_this);
            } else {
                _this.$http.post(
                    ["/menu/list"],
                    [
                        function (data) {
                            _this.menus = data;
                            _this.setFirstRouter(_this);
                            window.sessionStorage.setItem(
                                "menus",
                                JSON.stringify(data)
                            );
                        },
                    ],
                    ".nav-menu"
                );
            }
        },
        setFirstRouter(_this) {
            let data = _this.menus;

            for (var m in data) {
                if (data[m].sub) {
                    _this.setDefaultactive(data[m].sub[0].router);
                    break;
                }
            }
        },
        selectMenu(router) {
            window.sessionStorage.setItem("checked-menu", router);
        },
        setDefaultactive(router) {
            if (
                window.sessionStorage.getItem("checked-menu") &&
                this.hasRoute(window.sessionStorage.getItem("checked-menu"))
            ) {
                router = window.sessionStorage.getItem("checked-menu");
            } else {
                this.selectMenu(router);
            }

            this.defaultactive = router;

            if (this.$router.currentRoute.path != router) {
                this.$router.push(router);
            }
        },
        hasRoute(name, routeList) {
            routeList = routeList ? routeList : this.$router.options.routes;

            for (let i = 0; i < routeList.length; i++) {
                if (routeList[i].name === name) {
                    return true;
                }
                if (routeList[i].children) {
                    let flag = this.hasRoute(name, routeList[i].children);
                    if (flag) {
                        return flag;
                    }
                }
            }
            return false;
        },
    },
    mounted() {
        this.getMenu();
    },
    beforeMount() {
        let bodyHeight =
            document.documentElement.clienHeight || document.body.clientHeight;
    },
};
</script>


<style lang="scss">
.el-container {
    height: 100%;
}
.el-header,
.el-main {
    padding: 0;
    overflow: hidden;
}
.nav-head-div {
    min-height: 60px;
    background-color: #545c64;
}
.nav-head-title {
    font-size: 30px;
    padding: 8px;
    color: white;
}
.nav-head-avatar {
    float: right;
    margin-right: 10px;
    margin-top: 5px;
}
.nav-menu {
    height: 100%;
}
.main-button-bar,
.button-bar {
    margin: 10px;

    .search-row {
        margin-top: 5px;
        height: 40px;
    }
    .search-item {
        margin-right: 5px;
        width: 217px;

        .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }

    .search-link {
        margin-left: 5px;
    }

    .add-button {
        float: right;
        margin-right: 20px;
    }
}
.input-width-all {
    width: 100%;
}
</style>